import { connect } from "react-redux";
import get from "lodash/get";

import { getRoles as onGetRoles } from "../../actions/rolesActions";

const mapStateToProps = (state) => ({
  rolesDataState: state.roles.rolesDataState,
  roles: get(state, ["roles", "roles"], []),
  errors: get(state, ["users", "errors"], null),
});

const mapDispatchToProps = { onGetRoles };

const withRoles = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withRoles };
